import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { dealerTransfer, SalesTransferProject } from '@api/announcement';
import { DealerTransferInterface } from '@api/announcement/type';
import {
  dealerReturnProject,
  delProject,
  getLeads,
  salesTransferDealerProject,
  saveLeads
} from '@api/project';
import { SalesTransferDealerInterface } from '@api/project/type';
import ZeissButton from '@components/button';
import { ZeissInput } from '@components/input';
import RevertModal from '@components/revertModal';
import { ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { getCityItem } from '@utils/tool';
import { useSalesForm } from '@views/pages/AnnouncementDetails/hooks/Footer/Form/useSalesForm';
import { AnnFooterPopup } from '@views/pages/AnnouncementDetails/hooks/Footer/Popup/annFooterPopup';
import { DataFlagEnum } from '@views/pages/AnnouncementList/announcement';
import { Form, Input, message, Modal, Space } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import './index.scss';

const { TextArea } = Input;

interface PropsTs {
  noticeCode?: string;
  details?: any;
  getAnnInfo: () => void;
  handleClickEditBtn: () => void;
}
export const useFooter = ({
  details,
  getAnnInfo,
  handleClickEditBtn
}: PropsTs) => {
  const [open, setOpen] = useState(false);
  const [leadsIdOpen, setLeadsIdOpen] = useState(false);
  const [delOpen, setDelOpen] = useState(false);
  const [leadsData, setLeadsData] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [userInfos] = useRecoilState(userInfo);
  const [revertModalShow, setRevertModalShow] = useState<boolean>(false);
  const [delearModalOpen, setDelearModalOpen] = useState(false);

  const isDealer = userInfos.roleKeys === ROLE_KEYS_MAP.dealer;
  const isAdmin = userInfos.roleKeys === ROLE_KEYS_MAP.admin;
  const isSales = userInfos.roleKeys === ROLE_KEYS_MAP.sales;

  const { salesForm } = useSalesForm({
    details,
    form,
    noCapsuleTabs: true,
    type: 'sales',
    sectorName: details.sectorTypeValue
  });
  const handleDisplaySalesPopup = () => {
    setOpen(!open);
  };

  const handleDisplayAddLeadsIDPopup = () => {
    setLeadsIdOpen(!leadsIdOpen);
  };

  const onRevertConfirm = async () => {
    const params = {
      code: details.noticeProjectCode,
      operatorUserId: userInfos.userId,
      operatorUserName: userInfos.realName
    };
    await dealerReturnProject(params);
    getAnnInfo();
    setRevertModalShow(false);
  };

  const confirmCallback = async () => {
    try {
      const val = await form.validateFields();
      await delProject({
        noticeProjectCode: details.noticeProjectCode && [
          details.noticeProjectCode
        ],
        ...val
      });
      setOpen(false);
      message.success('删除成功!');
      navigate('/projectList');
    } catch (e) {
      console.log(e);
    }
  };

  const onDealerFinish = async (val: any) => {
    const { corpId, recordRemark, dispatchUserId } = val;
    const dispatchUserMap = getCityItem(dispatchUserId);

    if (userInfos.roleKeys === ROLE_KEYS_MAP.dealer) {
      const options: DealerTransferInterface = {
        noticeCode: details.noticeCode,
        userId: dispatchUserMap?.code ?? '',
        userName: dispatchUserMap?.label ?? '',
        noticeStatus: details?.noticeStatus,
        noticeStatusValue: details?.noticeStatusValue,
        recordRemark,
        currentProcessorUserId: userInfos.userId,
        currentProcessorUserName: userInfos.realName,
        scene: 5, // * 转交场景：  1.公告，5项目
        noticeProjectCode: details.noticeProjectCode
      };
      await dealerTransfer(options);
    } else {
      const options: SalesTransferDealerInterface = {
        projectCode: details.noticeProjectCode,
        recordRemark,
        userId: dispatchUserMap?.code ?? '',
        userName: dispatchUserMap?.label ?? '',
        currentProcessorUserId: userInfos.userId,
        currentProcessorUserName: userInfos.realName,
        corpId
      };

      await salesTransferDealerProject(options);
    }
    getAnnInfo();
  };

  const getProjectLeads = async () => {
    const res: any = await getLeads({
      projectCode: details.noticeProjectCode
    });
    form.setFieldsValue({
      leadsId: res?.leadsList || []
    });
    setLeadsData(res?.leadsList);
  };

  const onFinish = async (val: any) => {
    const salesInfo = val.sales && val.sales.split('-');
    const {
      userInfo: { userId, realName }
    } = JSON.parse(localStorage.getItem('recoil-persist') || '{}');
    await SalesTransferProject({
      projectCode: details.noticeProjectCode,
      userId: salesInfo && salesInfo[0],
      userName: salesInfo && salesInfo[1],
      recordRemark: val.recordRemark,
      currentProcessorUserId: userId,
      currentProcessorUserName: realName
    });
    message.success('转交成功');
    handleDisplaySalesPopup();
    navigate('/projectList');
  };

  const createLeadsId = async (val: any) => {
    await saveLeads({
      projectCode: details.noticeProjectCode,
      leadsList: val.leadsId || []
    });
    getAnnInfo();
    getProjectLeads();
    setLeadsIdOpen(false);
  };

  useEffect(() => {
    details.noticeProjectCode && getProjectLeads();
  }, [details.noticeProjectCode]);

  const projectFooterComponent = (
    <Space size={'middle'} className="pc-footer-position">
      {isAdmin && (
        <ZeissButton
          type="primary"
          className="pc-footer-btn pc-footer-pro-btn-transfer"
          onClick={handleDisplayAddLeadsIDPopup}
        >
          关联Leads ID
        </ZeissButton>
      )}

      <ZeissButton
        type={isDealer ? 'primary' : 'default'}
        className="pc-footer-btn pc-footer-pro-btn-transfer"
        onClick={
          isDealer ? () => setDelearModalOpen(true) : handleDisplaySalesPopup
        }
      >
        转交
      </ZeissButton>
      {details.dataFlag === DataFlagEnum.dealer && !isDealer && (
        <ZeissButton
          // type="primary"
          className="pc-footer-btn pc-footer-pro-btn-transfer"
          onClick={() => setDelearModalOpen(true)}
        >
          分配给经销商
        </ZeissButton>
      )}

      {isDealer && userInfos.userId !== details.createUserId && (
        <>
          <ZeissButton
            danger
            className="pc-footer-btn"
            onClick={() => setRevertModalShow(true)}
          >
            退回
          </ZeissButton>
        </>
      )}
      <ZeissButton
        type="primary"
        className="pc-footer-btn"
        onClick={handleClickEditBtn}
      >
        编辑项目
      </ZeissButton>

      <ZeissButton
        danger
        className="pc-footer-btn"
        onClick={() => setDelOpen(!delOpen)}
      >
        删除项目
      </ZeissButton>
      <RevertModal
        title="确认删除该项目？"
        open={delOpen}
        onCancel={() => setDelOpen(false)}
        onConfirm={confirmCallback}
      >
        <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
          <Form.Item
            label={'备注：'}
            name={'remark'}
            rules={[{ required: true }]}
          >
            <TextArea placeholder="输入备注内容" rows={3} />
          </Form.Item>
        </Form>
      </RevertModal>
      <Modal
        width={520}
        open={open}
        onCancel={handleDisplaySalesPopup}
        footer={null}
        destroyOnClose={true}
        centered
      >
        <div className="pc-forwardAnn-layout">
          <div className="pc-forwardAnn-title">选择转交销售</div>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            {salesForm}
            <Space className="pc-forwardAnn-footer" size="middle">
              <ZeissButton
                className="pc-normal-btn"
                onClick={handleDisplaySalesPopup}
              >
                取消
              </ZeissButton>
              <ZeissButton htmlType="submit" className="pc-confirm-btn">
                确认转交
              </ZeissButton>
            </Space>
          </Form>
        </div>
      </Modal>
      <Modal
        width={520}
        open={leadsIdOpen}
        onCancel={handleDisplayAddLeadsIDPopup}
        footer={null}
        destroyOnClose={true}
        centered
      >
        <div className="pc-forwardAnn-layout">
          <div className="pc-forwardAnn-title">关联Leads ID</div>
          <Form form={form} layout="vertical" onFinish={createLeadsId}>
            <Form.List name="leadsId">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space
                      key={key}
                      style={{ display: 'flex', marginBottom: 8 }}
                      align="baseline"
                    >
                      <Form.Item
                        {...restField}
                        name={[name]}
                        rules={[{ required: true, message: '请填写Leads ID' }]}
                      >
                        <ZeissInput placeholder="请填写Leads ID" />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <ZeissButton
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      新增一条
                    </ZeissButton>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <Space className="pc-forwardAnn-footer" size="middle">
              <ZeissButton
                className="pc-normal-btn"
                onClick={handleDisplayAddLeadsIDPopup}
              >
                取消
              </ZeissButton>
              <ZeissButton htmlType="submit" className="pc-confirm-btn">
                确认
              </ZeissButton>
            </Space>
          </Form>
        </div>
      </Modal>
      <RevertModal
        title="是否退回该项目?"
        open={revertModalShow}
        onCancel={() => setRevertModalShow(false)}
        onConfirm={onRevertConfirm}
      />
      <AnnFooterPopup
        getAnnInfo={getAnnInfo}
        details={details}
        noticeCode={details.noticeCode}
        actionId={8}
        confirmCallback={onDealerFinish}
        open={delearModalOpen}
        setOpen={setDelearModalOpen}
      />
    </Space>
  );
  return {
    projectFooterComponent,
    leadsData
  };
};
